// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__30PJE","rootSuccess":"CompleteLink_rootSuccess__2oP3C","rootFailure":"CompleteLink_rootFailure__20pXM","isDisabled":"CompleteLink_isDisabled__1Tmw0"};